export default __webpack_public_path__ + "static/media/logo.c9bf0c5d.png";